import { z } from 'zod';

export const loginSchema = z.object({
  email: z
    .string()
    .email('validation.invalidEmail')
    .min(1, 'validation.emailRequired'),
  password: z.string().min(1, 'validation.passwordRequired'),
});
export type LoginFormValues = z.infer<typeof loginSchema>;

export const registerSchema = z
  .object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    email: z
      .string()
      .email('validation.invalidEmail')
      .min(1, 'validation.emailRequired'),
    password: z.string().min(6, 'validation.passwordMin'),
    confirmPassword: z.string().min(1, 'validation.confirmPasswordRequired'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'validation.passwordsMustMatch',
    path: ['confirmPassword'],
  });
export type RegisterFormValues = z.infer<typeof registerSchema>;

export const requestResetSchema = z.object({
  email: z
    .string()
    .email('validation.invalidEmail')
    .min(1, 'validation.emailRequired'),
});
export type RequestResetFormValues = z.infer<typeof requestResetSchema>;

export const resetPasswordSchema = z
  .object({
    password: z.string().min(6, 'validation.passwordMin'),
    confirmPassword: z.string().min(1, 'validation.confirmPasswordRequired'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'validation.passwordsMustMatch',
    path: ['confirmPassword'],
  });
export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;
